import "./inc/retail_user.js";
import "./inc/read_more.js";
import "./inc/utm_params.js";
import "./inc/nearby_search.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));
triggerTabList.forEach(function (triggerEl) {
    var tabTrigger = new bootstrap.Tab(triggerEl);
    var hash = '#' + triggerEl.href.split("#")[1];
    var tabBtn = document.querySelector(hash + "-tab");
    triggerEl.addEventListener("click", function (event) {
        event.preventDefault();
        tabBtn.click();
    })
})
// END Trigger Tabs By Hash
// ========================
// ========================
// == Add class to main navbar on scroll
const navbar = document.querySelector('#site-nav');
window.addEventListener('scroll', function () {
    let scroll = window.scrollY;
    if (scroll > navbar.offsetTop) {
        navbar.classList.add("scrolled");
    } else {
        navbar.classList.remove("scrolled");
    }
});
// END scrolled
// ========================
// ========================
// == Panzoom =============
const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");
if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale: 0.5,
        maxScale: 3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}
for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e) => { e.classList.remove('active-bg') })
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        panZoomImg.src = imgUrl;
    });
}
// END Panzoom ============
// ========================
/*
* FANCYBOX
*
* The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
* the carousel is first initilaized. To avoid triggering 3 image view events on every
* Fancybox initCarousel action, an imageview event is triggered on the initCarousel
* event, but "done" events are then ignored for 1 second. After 1 second, image view
* events will be triggered as typical.
*/
// Tracks fancybox image views.
let fancyboxEventBlock = false
/** Abstracted event action handler
* @param {import("@fancyapps/ui").Fancybox} fancybox
*/
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}
// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});
/* END FANCYBOX */
// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.
window.addEventListener('load', function () {
    oi.utils.wrap_oi_aspect();
}, false);
/******************************************************************************/
/*                                                                            */
/*                                                                            */
/*                                                                            */
/*                          theme script start                                */
/*                                                                            */
/*                                                                            */
/*                                                                            */
/******************************************************************************/
document.addEventListener("DOMContentLoaded", () => {
    const siteNavHeight = document.getElementById('site-nav').offsetHeight;
    document.documentElement.style.setProperty('--site-nav-height', siteNavHeight + 'px');

    initNav();
    initBackdropController();
    initHeroSearch();
    initOffcanvasBackdropSync();
    initProcess();
    initOfferBanner();
    initHeroVideo();
    initMapListToggle();
    setMapWrapHeight();
    /* filter UI script */
    initFilterScripts();
    initListPageModelCardSwipers();
    initShareToggle();
    initActiveOnHover();
    initMarketMapClick();
    initLoadMore();
    initSpecSlider();
    initCommunitySpecFilter();
    initPlanSlider();
    initModelHomesSwiper();
    initSchoolImageSlider();
    initMarketRouting();
    initAdvantageVideo();
    initStackedCardsFallback();
    initFaqCategoryFilter();
    initImgReveal();
    initCompareScheduleTour();
});
window.addEventListener('resize', setMapWrapHeight);
// oifilter.js calls window.afterResultsSuccess() right after it swaps the
// #oi-filter-results innerHTML and before it re-fits the map. The freshly
// injected .list-page-card-container loses the inline height setMapWrapHeight()
// applied on load (and the empty-results markup drops the class entirely), so
// the row collapses and the map column shrinks to nothing. Re-apply the height
// on every AJAX result swap so the map stays full-height after filtering/sorting.
window.afterResultsSuccess = setMapWrapHeight;
window.addEventListener('load', setModelHeroHeight);
window.addEventListener('resize', setModelHeroHeight);
/* nav */
function initNav() {
    const nav = document.getElementById("site-nav");
    if (!nav) return;
    const dropdowns = nav.querySelectorAll(".dropdown");
    let openCount = 0;
    const MEGA_MENU_BOTTOM_PADDING = 40; // breathing room below the last dropdown item
    function updateMegaMenuHeight(dropdown) {
        const menu = dropdown.querySelector(".dropdown-menu");
        if (!menu) return;
        const navBottom = nav.getBoundingClientRect().bottom;
        const menuBottom = menu.getBoundingClientRect().bottom;
        const height = Math.max(0, menuBottom - navBottom) + MEGA_MENU_BOTTOM_PADDING;
        nav.style.setProperty("--mega-menu-height", height + "px");
    }
    dropdowns.forEach(dropdown => {
        dropdown.addEventListener("show.bs.dropdown", () => {
            openCount++;
            nav.classList.add("mega-open");
        });
        dropdown.addEventListener("shown.bs.dropdown", () => {
            updateMegaMenuHeight(dropdown);
        });
        dropdown.addEventListener("hide.bs.dropdown", () => {
            openCount--;
            requestAnimationFrame(() => {
                // 🔥 allow Bootstrap to finish switching dropdowns
                setTimeout(() => {
                    if (openCount <= 0) {
                        openCount = 0;
                        nav.classList.remove("mega-open");
                    }
                }, 10);
            });
        });
    });
    document.addEventListener("click", (e) => {
        if (!nav.contains(e.target)) {
            nav.classList.remove("mega-open");
            openCount = 0;
            nav.querySelectorAll(".dropdown.show").forEach(dd => {
                const instance = bootstrap.Dropdown.getInstance(dd);
                if (instance) instance.hide();
            });
        }
    });
}
/* backdrop controller (global state) */
function initBackdropController() {
    const backdrop = document.querySelector(".custom-backdrop");
    if (!backdrop) return;
    window.BackdropState = {
        search: false,
        offcanvas: false,
        el: backdrop
    };
    window.updateBackdrop = function () {
        const show = window.BackdropState.search || window.BackdropState.offcanvas;
        backdrop.style.display = show ? "block" : "none";
        document.body.classList.toggle("custom-backdrop-open", show);
    };
    backdrop.addEventListener("click", () => {
        window.BackdropState.search = false;
        window.updateBackdrop();
        const search = document.querySelector(".hero-search-by-market");
        const input = document.getElementById("hero-search-bar");
        if (search) search.classList.add("d-none");
        if (input) input.style.zIndex = "";
    });
}
/* hero search */
function initHeroSearch() {
    const heroSearchBar = document.getElementById("hero-search-bar");
    const searchByMarket = document.querySelector(".hero-search-by-market");
    if (!heroSearchBar || !searchByMarket) return;
    // -------------------------
    // SHOW
    // -------------------------
    const showDropdown = () => {
        searchByMarket.classList.remove("d-none");
    };
    // -------------------------
    // HIDE
    // -------------------------
    const hideDropdown = () => {
        searchByMarket.classList.add("d-none");
    };
    // -------------------------
    // OPEN LOGIC
    // -------------------------
    const openSearch = () => {
        window.BackdropState.search = true;
        window.updateBackdrop();
        heroSearchBar.style.position = "relative";
        heroSearchBar.style.zIndex = "1050";
        showDropdown();
    };
    // -------------------------
    // CLOSE LOGIC
    // -------------------------
    const closeSearch = () => {
        window.BackdropState.search = false;
        window.updateBackdrop();
        heroSearchBar.style.zIndex = "";
        hideDropdown();
    };
    // -------------------------
    // FOCUS (MAIN ENTRY POINT)
    // -------------------------
    heroSearchBar.addEventListener("focus", () => {
        const value = heroSearchBar.value?.trim();
        openSearch();
        // only show dropdown when empty
        if (value) {
            hideDropdown();
        } else {
            showDropdown();
        }
    });
    // -------------------------
    // CLICK (backup entry)
    // -------------------------
    heroSearchBar.addEventListener("click", (e) => {
        const value = heroSearchBar.value?.trim();
        openSearch();
        if (!value) {
            showDropdown();
        } else {
            hideDropdown();
        }
        e.stopPropagation();
    });
    // -------------------------
    // INPUT (SOURCE OF TRUTH)
    // -------------------------
    heroSearchBar.addEventListener("input", (e) => {
        const value = e.target.value?.trim();
        if (value.length > 0) {
            hideDropdown();
        } else {
            showDropdown();
        }
    });
    // -------------------------
    // OUTSIDE CLICK (SAFE CLOSE ONLY)
    // -------------------------
    document.addEventListener("click", (e) => {
        const offcanvas = document.querySelector(".offcanvas.show");
        const isInside =
            heroSearchBar.contains(e.target) ||
            searchByMarket.contains(e.target);
        const isInsideOffcanvas =
            offcanvas && offcanvas.contains(e.target);
        if (isInsideOffcanvas) return;
        if (!isInside) {
            closeSearch();
        }
    });
    // -------------------------
    // BACKDROP CLICK
    // -------------------------
    const backdrop = window.BackdropState?.el;
    if (backdrop) {
        backdrop.addEventListener("click", closeSearch);
    }
}
/* offcanvas backdrop sync */
function initOffcanvasBackdropSync() {
    document.addEventListener("shown.bs.offcanvas", () => {
        window.BackdropState.offcanvas = true;
        window.updateBackdrop();
    });
    document.addEventListener("hidden.bs.offcanvas", () => {
        window.BackdropState.offcanvas = false;
        window.updateBackdrop();
    });
}
/* process section */
function initProcess() {
    const buttons = document.querySelectorAll(".process-list .process-link");
    const images = document.querySelectorAll(".homepage-process-section img");
    const processWrap = document.querySelector(".homepage-process-section");
    if (!processWrap || !buttons.length) return;
    function setActive(id) {
        images.forEach(img => {
            img.classList.toggle("active", img.dataset?.id === id);
        });
        buttons.forEach(btn => {
            btn.classList.toggle("active", btn.id === id);
        });
    }
    buttons.forEach(button => {
        if (!button.id) return;
        button.addEventListener("click", () => setActive(button.id));
        button.addEventListener("mouseenter", () => setActive(button.id));
    });
    const defaultId = buttons[0]?.id;
    if (defaultId) setActive(defaultId);
}
/* promo banner toast session handling */
function initOfferBanner() {
    const topBanner = document.getElementById('top-offer-banner');
    const stickyWidget = document.getElementById('sticky-offer-widget');
    const closeTop = document.getElementById('close-top-banner');
    const closeSticky = document.getElementById('close-sticky-widget');
    if (!topBanner || !stickyWidget || !closeTop || !closeSticky) return;
    // The top banner is sticky, and the site-nav sticks right below it — keep
    // --top-banner-height in sync so site-nav/model-sub-nav don't overlap it,
    // and so it collapses back to 0 once the banner is dismissed.
    function updateTopBannerHeightVar() {
        document.documentElement.style.setProperty('--top-banner-height', topBanner.offsetHeight + 'px');
    }
    // 1. Session storage check
    if (sessionStorage.getItem('hideOfferPermanently') === 'true') {
        topBanner.classList.add('d-none');
        stickyWidget.classList.add('d-none');
        updateTopBannerHeightVar();
        return;
    }
    updateTopBannerHeightVar();
    window.addEventListener('resize', updateTopBannerHeightVar);
    // 2. Close top banner → show sticky
    closeTop.addEventListener('click', () => {
        topBanner.classList.add('d-none');
        stickyWidget.classList.remove('d-none');
        updateTopBannerHeightVar();
    });
    // 3. Close sticky → hide everything for session
    closeSticky.addEventListener('click', () => {
        stickyWidget.classList.add('d-none');
        sessionStorage.setItem('hideOfferPermanently', 'true');
    });
}
/* homepage video hero */
function initHeroVideo() {
    const video = document.querySelector('.homepage-hero iframe');
    const hero = document.querySelector('.homepage-hero');
    const nav = document.getElementById('site-nav');
    if (!hero) return;
    function resizeHeroVideo() {
        if (window.innerWidth >= 768) return;
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        // 1. Adjust hero height based on nav
        if (nav) {
            const navHeight = nav.offsetHeight;
            hero.style.height = `${windowHeight - navHeight}px`;
        }
        // 2. Handle video scaling
        if (!video) return;
        if (windowHeight / windowWidth > 0.5625) {
            const newWidth = windowHeight * 1.77;
            video.style.width = `${newWidth}px`;
            video.style.height = `${windowHeight}px`;
            video.style.marginLeft = `${-(newWidth - windowWidth) / 2}px`;
            video.style.marginTop = '0';
        }
    }
    function handleResize() {
        if (window.innerWidth < 768) {
            resizeHeroVideo();
        } else {
            // Reset styles when leaving mobile
            hero.style.height = '';
            if (video) {
                video.style.width = '';
                video.style.height = '';
                video.style.marginLeft = '';
                video.style.marginTop = '';
            }
        }
    }
    // Initial run
    handleResize();
    // Events
    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);
}
/* list page filters UI script */
/* initBootstrapFilterDropdowns() keeps the dropdown open for interactions */
function initBootstrapFilterDropdowns() {
    document.querySelectorAll('.filter-wrapper .dropdown-toggle').forEach(dropdown => {
        new bootstrap.Dropdown(dropdown, {
            autoClose: 'outside'
        });
    });
}
/* initToggleMoreLess() add read more/less inside more filter offCanvas */
function initToggleMoreLess() {
    document.querySelectorAll('[data-toggle-btn]').forEach(btn => {
        const targetId = btn.getAttribute('aria-controls');
        const wrapper = document.getElementById(targetId);
        if (!wrapper) return;
        btn.addEventListener('click', () => {
            const isCollapsed = wrapper.classList.toggle('collapsed');
            btn.textContent = isCollapsed ? 'View More' : 'View Less';
            btn.setAttribute('aria-expanded', String(!isCollapsed));
        });
    });
}
/* initFilterSystem() updates button to reflect filter selections being made */
function initFilterSystem() {
    document.querySelectorAll('.dropdown[data-filter-group]').forEach(dropdown => {
        const button = dropdown.querySelector('.dropdown-toggle');
        const applyBtn = dropdown.querySelector('.btn-apply');
        if (!button || !applyBtn) return;
        applyBtn.addEventListener('click', () => {
            const group = dropdown.getAttribute('data-filter-group');
            let label = buildLabel(group, dropdown);
            if (label) button.innerText = label;
            const instance = bootstrap.Dropdown.getInstance(button);
            if (instance) instance.hide();
        });
    });
    function buildLabel(group, dropdown) {
        // =====================
        // BEDS / BATHS
        // =====================
        if (group === 'beds-baths') {
            const beds = getRadioValue(dropdown, 'beds', 'Bed');
            const baths = getRadioValue(dropdown, 'baths', 'Bath');
            return `${beds}, ${baths}`;
        }
        // =====================
        // PRICE
        // =====================
        if (group === 'price') {
            const min = dropdown.querySelector('[data-filter="price-min"]')?.value;
            const max = dropdown.querySelector('[data-filter="price-max"]')?.value;
            return formatRange(min, max, 'Price');
        }
        // =====================
        // SQFT
        // =====================
        if (group === 'sqft') {
            const min = dropdown.querySelector('[data-filter="sqft-min"]')?.value;
            const max = dropdown.querySelector('[data-filter="sqft-max"]')?.value;
            return formatRange(min, max, 'Sq Ft');
        }
        return null;
    }
    function getRadioValue(scope, name, label) {
        const selected = scope.querySelector(`input[name="${name}"]:checked`);
        const text = selected?.nextElementSibling?.innerText?.trim() || 'Any';
        return text === 'Any' ? `Any ${label}s` : `${text} ${label}s`;
    }
    function formatRange(min, max, label) {
        const minText = min || 'No Min';
        const maxText = max || 'No Max';
        if (minText === 'No Min' && maxText === 'No Max') {
            return `${label}`;
        }
        return `${minText} - ${maxText}`;
    }
}
function initFilterScripts() {
    initBootstrapFilterDropdowns();
    initToggleMoreLess();
    initFilterSystem();
}
/* comman map list/map view toggle script */
function initMapListToggle() {
    const showMap = document.getElementById('btn-map');
    const showList = document.getElementById('btn-list');
    const mapWrapper = document.getElementById('map-wrap');
    const listWrapper = document.getElementById('list-wrap');
    if (!showMap || !showList || !mapWrapper || !listWrapper) return;
    function loadMobileMap() {
        if (window.oi && oi.map) {
            setTimeout(function () {
                if (typeof mobile_map === 'function') {
                    mobile_map();
                }
            }, 1000);
        } else {
            window.addEventListener('oilib_loaded', function handler() {
                window.removeEventListener('oilib_loaded', handler);
                setTimeout(function () {
                    if (typeof mobile_map === 'function') {
                        mobile_map();
                    }
                }, 1000);
            });
        }
    }
    showMap.addEventListener('click', function () {
        mapWrapper.classList.remove('d-none');
        listWrapper.classList.add('d-none');
        showMap.classList.add('d-none');
        showList.classList.remove('d-none');
        loadMobileMap();
    });
    showList.addEventListener('click', function () {
        mapWrapper.classList.add('d-none');
        listWrapper.classList.remove('d-none');
        showList.classList.add('d-none');
        showMap.classList.remove('d-none');
    });
}
/* Pin the side-by-side map+list layout to the viewport height. */
/* On large screens the list column (#oi-filter-results) is fixed at 100vh minus */
/* the headers and scrolls internally; on small screens the map gets that height. */
function setMapWrapHeight() {
    const mapContainer = document.querySelector('.map-wrap');
    // Only the side-by-side layout (a .map-wrap column next to the list) needs a
    // pinned, synced height. Stacked/full-width filter pages flow naturally.
    if (!mapContainer) return;
    // Pin the height on #oi-filter-results (the stable AJAX target), NOT the inner
    // .list-page-card-container. oifilter.js swaps that inner row on every filter
    // (and drops it entirely when there are no results), so a height set there is
    // lost on the next filter and the map column collapses. The card row fills this
    // wrapper and scrolls inside it (see _maps.scss). This is why the height must
    // also be re-applied on each AJAX swap via window.afterResultsSuccess.
    const listContainer = document.getElementById('oi-filter-results');
    const ids = ['top-offer-banner', 'site-nav', 'oi-filter-form'];
    const totalHeight = ids.reduce(function (sum, id) {
        const el = document.getElementById(id);
        return sum + (el ? el.offsetHeight : 0);
    }, 0);
    const heightValue = `calc(100vh - ${totalHeight}px)`;
    if (window.innerWidth > 991) {
        if (listContainer) listContainer.style.height = heightValue;
        mapContainer.style.height = '';
    } else {
        mapContainer.style.height = heightValue;
        if (listContainer) listContainer.style.height = '';
    }
}
/* list page location/spec cards swiper */
function initListPageModelCardSwipers() {
    const swipers = document.querySelectorAll('.model-swiper');
    swipers.forEach(swiperEl => {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        const hasMultipleSlides = slides.length > 1;
        new Swiper(swiperEl, {
            a11y: true,
            keyboard: true,
            loop: hasMultipleSlides,
            speed: 600,
            pagination: hasMultipleSlides ? {
                el: swiperEl.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 3
            } : false,
            navigation: hasMultipleSlides ? {
                nextEl: swiperEl.querySelector('.swiper-button-next'),
                prevEl: swiperEl.querySelector('.swiper-button-prev')
            } : false
        });
    });
}
/* compare page/modal share script */
function initShareToggle(toggleId = 'shareToggle', menuId = 'shareMenu') {
    const shareToggle = document.getElementById(toggleId);
    const shareMenu = document.getElementById(menuId);
    if (!shareToggle || !shareMenu) return;
    // Prevent duplicate bindings
    if (shareToggle.dataset.shareInitialized === 'true') return;
    shareToggle.dataset.shareInitialized = 'true';
    shareToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        shareMenu.classList.toggle('d-none');
    });
    document.addEventListener('click', function (e) {
        if (!shareMenu.contains(e.target) && e.target !== shareToggle) {
            shareMenu.classList.add('d-none');
        }
    });
}
/* market map click: filter map pins to the clicked market */
function initMarketMapClick() {
    const marketItems = document.querySelectorAll('li[data-market-id] .market-card');
    const mapEl = document.getElementById('oi-map');
    if (!marketItems.length || !mapEl) return;

    const allPins = document.querySelectorAll('.oi-map-item[data-market-id]');
    if (!allPins.length) return;

    const overlay = document.getElementById('map-loading-overlay');
    /** @type {ReturnType<typeof setTimeout>|null} */
    let overlayTimer = null;

    function showOverlay() {
        if (!overlay) return;
        overlay.style.display = 'flex';
        clearTimeout(overlayTimer);
        overlayTimer = setTimeout(() => { overlay.style.display = 'none'; }, 1000);
    }

    function getMapInstance() {
        return window.oi?.loaded?.map?.['oi-map'];
    }

    function zoomIfSinglePin() {
        const map = getMapInstance();
        if (map && map.map) map.map.setZoom(15);
    }

    function filterMap(marketId) {
        allPins.forEach(pin => {
            pin.style.display = (!marketId || pin.dataset.marketId === marketId) ? '' : 'none';
        });
        const map = getMapInstance();
        if (map) {
            map.set_markers('location');
            if (marketId) {
                showOverlay();
                map.fit();
                const visiblePins = Array.from(allPins).filter(p => p.style.display !== 'none');
                if (visiblePins.length === 1 && map.map) {
                    google.maps.event.addListenerOnce(map.map, 'idle', zoomIfSinglePin);
                }
            }
        }
    }

    // Initial load: zoom in when the map is ready if there is only 1 location total
    if (allPins.length === 1) {
        window.addEventListener('oimap_idle', zoomIfSinglePin, { once: true });
    }

    marketItems.forEach(card => {
        const li = card.closest('li[data-market-id]');
        if (!li) return;
        card.addEventListener('click', function (e) {
            const target = /** @type {Element} */ (e.target);
            if (target.closest('a')) return;
            // The preview image isn't its own link (that duplicated the arrow link for
            // screen readers / a11y checkers); clicking it follows the arrow link instead.
            if (target.closest('.market-card-image')) {
                const link = /** @type {HTMLAnchorElement|null} */ (card.querySelector('.market-card-link'));
                if (link) window.location.href = link.href;
                return;
            }
            const isActive = card.classList.contains('active');
            marketItems.forEach(c => c.classList.remove('active'));
            if (isActive) {
                filterMap(null);
            } else {
                card.classList.add('active');
                filterMap(li.dataset.marketId);
            }
        });
    });
}
/* on hover add .active script */
function initActiveOnHover() {
    const cards = document.querySelectorAll('.get-active-on-hover');
    if (!cards.length) return;
    cards.forEach(card => {
        card.addEventListener('mouseenter', function () {
            cards.forEach(el => el.classList.remove('active'));
            this.classList.add('active');
        });
    });
}
/* load more cards script */
function initLoadMore() {
    const button = document.querySelector('.load-more');
    if (!button) return;
    button.addEventListener('click', function () {
        document.querySelectorAll('.d-none.d-md-block').forEach(function (el) {
            el.classList.remove('d-none');
        });
        button.style.display = 'none';
    });
}
/* community detail spec slider filter chips
 * oifilter.js owns the AJAX call (via oi-filter-click on the chips); this
 * function only updates the hidden inputs and toggles active states before
 * oifilter.js fires, and overrides afterResultsSuccess to reinit Swiper.
 */
function initCommunitySpecFilter() {
    const filterForm = document.getElementById('oi-filter-form');
    if (!filterForm || filterForm.dataset.filterType !== 'loc-spec-slider') return;

    // Belt-and-suspenders: block any native form submission so hidden inputs
    // never appear as query params in the URL (buttons are type="button" but guard anyway).
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); });

    filterForm.querySelectorAll('.available-homes-filter-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
            const key = chip.dataset.filterKey;
            const value = chip.dataset.value;
            const inputId = key === 'home_type' ? 'slider-home-type-input' : 'slider-availability-input';
            const input = document.getElementById(inputId);
            if (!input) return;

            // Toggle: clicking the active chip clears the filter (show all).
            const next = (input.value === value) ? '' : value;
            input.value = next;
            filterForm.querySelectorAll(`[data-filter-key="${key}"]`).forEach(function (c) {
                c.classList.toggle('active', c.dataset.value === next && next !== '');
            });
            // oifilter.js handles the AJAX post via oi-filter-click (fires after this handler).
        });
    });

    // After oifilter.js swaps the swiper-wrapper innerHTML, destroy the stale
    // Swiper instance and reinit so the new slides are navigable.
    window.afterResultsSuccess = function () {
        const container = document.querySelector('.spec-slider-area .swiper-container');
        if (container && container.swiper) {
            container.swiper.destroy(true, true);
        }
        initSpecSlider();
    };
}
/* spec-slider */
function initSpecSlider() {
    const slider = document.querySelector('.spec-slider-area .swiper-container');
    if (!slider || typeof Swiper === 'undefined') {
        return;
    }
    new Swiper(slider, {
        a11y: true,
        keyboard: true,
        slidesPerView: 1.1,
        centeredSlides: true,
        // spaceBetween: 5,
        loop: true,
        navigation: {
            nextEl: '.nav-next',
            prevEl: '.nav-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1.5,
            }
        }
    });
}
/* plan-slider */
function initPlanSlider() {
    const containers = document.querySelectorAll('.plan-slider-area .swiper-container');
    if (!containers.length || typeof Swiper === 'undefined') return;
    const planSwipers = {};
    containers.forEach(function (el) {
        planSwipers[el.id] = new Swiper(el, {
            a11y: true,
            keyboard: true,
            slidesPerView: 1.1,
            centeredSlides: true,
            loop: true,
            breakpoints: {
                768: { slidesPerView: 1.5 }
            }
        });
    });
    let activePlanSwiper = Object.values(planSwipers)[0];
    document.querySelectorAll('#nav-tab [data-bs-toggle="tab"]').forEach(function (tab) {
        tab.addEventListener('shown.bs.tab', function () {
            const slug = (tab.getAttribute('data-bs-target') || '').replace('#nav-', '');
            const swiper = planSwipers['swiper-plan-' + slug];
            if (swiper) {
                activePlanSwiper = swiper;
                activePlanSwiper.update();
            }
        });
    });
    document.querySelector('.plan-nav-prev')?.addEventListener('click', () => activePlanSwiper?.slidePrev());
    document.querySelector('.plan-nav-next')?.addEventListener('click', () => activePlanSwiper?.slideNext());
}
/* model-homes-slider */
function initModelHomesSwiper() {
    const el = document.querySelector('#swiper-model-homes');
    if (!el || typeof Swiper === 'undefined') return;
    const modelHomesSwiper = new Swiper(el, {
        a11y: true,
        keyboard: true,
        slidesPerView: 1.1,
        spaceBetween: 16,
        centeredSlides: true,
        loop: false,
        breakpoints: {
            768: { slidesPerView: 2, centeredSlides: false },
            1024: { slidesPerView: 3, centeredSlides: false }
        }
    });
    document.querySelector('.model-homes-nav-prev')?.addEventListener('click', () => modelHomesSwiper.slidePrev());
    document.querySelector('.model-homes-nav-next')?.addEventListener('click', () => modelHomesSwiper.slideNext());
}
/* school-image-slider */
function initSchoolImageSlider() {
    const sliders = document.querySelectorAll('.school-image-slider');
    if (!sliders.length || typeof Swiper === 'undefined') return;
    sliders.forEach((slider) => {
        new Swiper(slider, {
            a11y: true,
            keyboard: true,
            slidesPerView: 1.1,
            spaceBetween: 0,
            centeredSlides: false,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: { slidesPerView: 1.1 },
                768: { slidesPerView: 1.1 }
            }
        });
    });
}
/* market routing: preferred_market_url cookie + modal orchestration.
 * preferred_market_url always stores the bare market base URL
 * (e.g. "/new-homes/tx/austin/", from {% permalink_tag market %}) with no
 * suffix baked in — every consumer appends its own "available/",
 * "communities/", or "special-offers/" suffix. */
function initMarketRouting() {
    function getPreferredMarketUrl() {
        const match = document.cookie.match(/(?:^|;\s*)preferred_market_url=([^;]+)/);
        return match ? decodeURIComponent(match[1]) : null;
    }
    /** @param {string} name @param {string} value */
    function setCookie(name, value) {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; expires=' + expires.toUTCString();
    }

    // Special offers CTAs — banner top, sticky widget, featured promo on list page
    ['promo-banner-cta', 'promo-sticky-cta', 'featured-promo-cta'].forEach(id => {
        const btn = document.getElementById(id);
        if (!btn) return;
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const marketUrl = getPreferredMarketUrl();
            if (marketUrl) {
                window.location.href = marketUrl + 'special-offers/';
            } else {
                const modalEl = document.getElementById('marketModal');
                if (modalEl) {
                    modalEl.dataset.specialOffersMode = '1';
                    bootstrap.Modal.getOrCreateInstance(modalEl).show();
                }
            }
        });
    });

    // Communities CTAs — explore communities section and map search dropdown
    // .map-search renders more than once per page (hero and footer), so bind every match.
    document.querySelectorAll('#explore-communities-cta, .map-search').forEach(btn => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const marketUrl = getPreferredMarketUrl();
            if (marketUrl) {
                window.location.href = marketUrl + 'communities/';
            } else {
                const modalEl = document.getElementById('marketModal');
                if (modalEl) {
                    modalEl.dataset.communitiesMode = '1';
                    bootstrap.Modal.getOrCreateInstance(modalEl).show();
                }
            }
        });
    });

    // View All Homes CTA — recommend section
    const viewAllHomesCta = document.getElementById('view-all-homes-cta');
    if (viewAllHomesCta) {
        viewAllHomesCta.addEventListener('click', function (e) {
            e.preventDefault();
            const marketUrl = getPreferredMarketUrl();
            if (marketUrl) {
                window.location.href = marketUrl + 'available/';
            } else {
                const modalEl = document.getElementById('marketModal');
                if (modalEl) {
                    modalEl.dataset.specsMode = '1';
                    bootstrap.Modal.getOrCreateInstance(modalEl).show();
                }
            }
        });
    }

    // "/new-homes/" nav links (desktop + mobile nav both render this markup) —
    // gated behind market selection the same way as View All Homes.
    document.querySelectorAll('[data-market-gate="specs"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const marketUrl = getPreferredMarketUrl();
            if (marketUrl) {
                window.location.href = marketUrl + 'available/';
            } else {
                const modalEl = document.getElementById('marketModal');
                if (modalEl) {
                    modalEl.dataset.specsMode = '1';
                    bootstrap.Modal.getOrCreateInstance(modalEl).show();
                }
            }
        });
    });

    // Market modal — write the cookie on selection, then route based on active mode
    const modal = document.getElementById('marketModal');
    if (!modal) return;

    modal.addEventListener('hide.bs.modal', function () {
        delete modal.dataset.specialOffersMode;
        delete modal.dataset.communitiesMode;
        delete modal.dataset.specsMode;
    });

    modal.addEventListener('click', function (e) {
        const link = /** @type {HTMLElement|null} */ (/** @type {Element} */ (e.target).closest('[data-market-slug]'));
        if (!link) return;
        const marketUrl = link.dataset.marketUrl || '';
        if (marketUrl) setCookie('preferred_market_url', marketUrl);
        if (modal.dataset.specialOffersMode === '1') {
            e.preventDefault();
            window.location.href = marketUrl + 'special-offers/';
        } else if (modal.dataset.communitiesMode === '1') {
            e.preventDefault();
            window.location.href = marketUrl + 'communities/';
        } else if (modal.dataset.specsMode === '1') {
            e.preventDefault();
            window.location.href = marketUrl + 'available/';
        }
    });
}
/* advantage page: autoplay video when scrolled into view */
function initAdvantageVideo() {
    const wrap = document.querySelector('.advantage-video-wrap');
    if (!wrap) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = wrap.querySelector('video');
            const iframe = wrap.querySelector('iframe');
            if (entry.isIntersecting) {
                if (video) {
                    video.play();
                } else if (iframe) {
                    const src = iframe.src || '';
                    if (src.includes('youtube.com')) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                    } else if (src.includes('vimeo.com')) {
                        iframe.contentWindow.postMessage('{"method":"play"}', '*');
                    }
                }
            } else {
                if (video) {
                    video.pause();
                } else if (iframe) {
                    const src = iframe.src || '';
                    if (src.includes('youtube.com')) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    } else if (src.includes('vimeo.com')) {
                        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                    }
                }
            }
        });
    }, { threshold: 0.3 });
    observer.observe(wrap);
}
/* stacked sticky cards (homepage "Modern Homes"/"Our Advantage" sections): the
 * shrink-and-fade exit transition between cards is driven in CSS by
 * view-timeline/animation-timeline (scroll-driven animations), which many
 * mobile browsers still don't support. Where that's the case the transition
 * never plays and the next sticky card just hard-overlaps the one before it.
 * This replicates the same translateZ shrink via scroll position instead, but
 * only where the native CSS feature is unsupported. */
function initStackedCardsFallback() {
    if (window.CSS && CSS.supports && CSS.supports('view-timeline-name: --oi-test')) {
        return;
    }
    document.querySelectorAll('.stacked-cards-container').forEach(function (container) {
        const cards = Array.from(container.querySelectorAll('.sticky-card'));
        if (cards.length < 2) return;
        function update() {
            cards.forEach(function (card, i) {
                if (i === cards.length - 1) return;
                const stickyTop = parseFloat(getComputedStyle(card).top) || 0;
                const cardHeight = card.offsetHeight || 1;
                // card.offsetTop/offsetHeight reflect normal-flow position and stay
                // stable even once the card is visually stuck (unlike
                // getBoundingClientRect(), which freezes the moment it sticks) —
                // window.scrollY keeps advancing, so this keeps progressing too.
                const stickStart = card.offsetTop - stickyTop;
                const stickEnd = stickStart + cardHeight;
                let progress = (window.scrollY - stickStart) / (stickEnd - stickStart);
                progress = Math.min(Math.max(progress, 0), 1);
                card.style.transform = progress > 0 ? 'translateZ(' + (-263 * progress) + 'px)' : '';
            });
        }
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });
}
/* image tiles (advantage + flex pages): slide images in as they scroll into view */
function initImgReveal() {
    const revealEls = document.querySelectorAll('.img-reveal');
    if (!revealEls.length) return;
    if (!('IntersectionObserver' in window)) {
        revealEls.forEach(function (el) { el.classList.add('in-view'); });
        return;
    }
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            entry.target.classList.toggle('in-view', entry.isIntersecting);
        });
    }, { threshold: 0.2 });
    revealEls.forEach(function (el) { observer.observe(el); });
}
/* faqs page: topic dropdown shows only the FAQs in the chosen topic ("all" shows every one) */
function initFaqCategoryFilter() {
    const filter = /** @type {HTMLSelectElement|null} */ (document.getElementById('faq-category-filter'));
    if (!filter) return;
    const items = document.querySelectorAll('#faqAccordion [data-faq-category]');
    filter.addEventListener('change', function () {
        const category = filter.value;
        items.forEach(function (item) {
            item.classList.toggle('d-none', category !== 'all' && /** @type {HTMLElement} */ (item).dataset.faqCategory !== category);
        });
    });
}
function setModelHeroHeight() {
    const hero = document.querySelector('.model-hero');
    const nav = document.getElementById('site-nav');
    const headerSection = document.querySelector('.model-header-section');

    if (!hero || !nav) return;

    if (window.innerWidth < 768) {
        const navHeight = nav.offsetHeight;
        const headerHeight = headerSection ? headerSection.offsetHeight : 0;

        hero.style.height = `calc(100vh - ${navHeight}px - ${headerHeight}px)`;
        hero.style.height = `calc(100dvh - ${navHeight}px - ${headerHeight}px)`;
    } else {
        hero.style.height = '';
    }
}
/******************************************************************************/
/*                                                                            */
/*                                                                            */
/*                                                                            */
/*                          theme script end                                  */
/*                                                                            */
/*                                                                            */
/*                                                                            */
/******************************************************************************/
/* compare: shared Schedule a Visit modal (inc_modal_compare_schedule_tour.html). Each
   compared item has its own tour URL, passed on the button's data-schedule-tour-url. */
function initCompareScheduleTour() {
    document.addEventListener('show.bs.modal', function (e) {
        if (e.target.id !== 'compare-schedule-tour-modal') return;
        const url = e.relatedTarget ? e.relatedTarget.dataset.scheduleTourUrl : '';
        const iframe = e.target.querySelector('iframe');
        if (iframe && url) iframe.src = url;
    });
    document.addEventListener('hidden.bs.modal', function (e) {
        if (e.target.id !== 'compare-schedule-tour-modal') return;
        const iframe = e.target.querySelector('iframe');
        if (iframe) iframe.src = '';
    });
}
